import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

<svg fill="none" height="14" viewBox="0 0 11 14" width="11" xmlns="http://www.w3.org/2000/svg" />;

export const FlagIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M0.5 13.5V7.00001M0.5 7.00001H4.5L6.25 8.75001H10V2.75001H6.25L4.5 1.00001L0.5 1V7.00001Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
